import React from 'react';
import { Link } from 'react-router-dom';

import Icone from 'Component/Icone';
import Imagem from 'Component/Imagem';
import Curso from 'Interface/Cursos';

interface Props {
    dados: Curso;
}

const Cartao = ({ dados }: Props): React.ReactElement =>
{
    return (
        <div className="position-relative hf-200 clip-rounded-3">
            <Link className="text-decoration-none" to={ `/estudar/curso/${dados.slug}` }>
                <Imagem
                    src={ dados.imagem }
                    className={ [
                        'w-100 h-100',
                        'position-absolute z-index-500',
                        'object-fit-cover',
                    ].class() }
                />
                <div
                    className={ [
                        'w-100 p-2',
                        'position-absolute z-index-1000',
                        'd-flex',
                        dados.categoria ? 'justify-content-between' : 'justify-content-end',
                        'text-white',
                    ].class() }
                >
                    { dados.categoria && (
                        <small className="d-inline-block px-1 bg-secondary rounded text-body fs-6 fw-bold">
                            { dados.categoria.nome }
                        </small>
                    ) }
                    <div className="bg-primary rounded-start me-n2 px-2">
                        <Icone nome='clock' className="me-2" />
                        { dados.carga_horaria }hrs
                    </div>
                </div>
                <p
                    className={ [
                        'w-100 p-3 mb-0',
                        'position-absolute bottom-0 z-index-1000',
                        'fs-5 fw-bold text-white',
                        'bg-gradient-black-to-top',
                    ].class() }
                >
                    <span className="d-block">
                        { dados.nome }
                    </span>
                </p>
            </Link>
        </div>
    );
}

export default Cartao;
